import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useProductMaster() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const productMasterData = getData(state, apiKeys.productMaster, []);
  const saveProductMasterStatus = getStatus(state, apiKeys.saveProductMaster, '');
  const updateProductMasterStatus = getStatus(state, apiKeys.updateProductMaster, '');
  const productMasterStatus = getStatus(state, apiKeys.productMaster, '');
  const productMasterErrMsg = getErrorMessage(state, apiKeys.productMaster, '');
  const deleteProductMasterStatus = getStatus(state, apiKeys.deleteProductMaster, '');

  const getProductMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.productMaster,
      method: apiMethods.GET,
      key: apiKeys.productMaster,
      failureMsg: formatMessage({ id: "failed-to-get-product-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getProductMaster()
  }, [dispatch, getProductMaster]);

  useEffect(() => {
    if (deleteProductMasterStatus === apiStatuses.succeeded) {
      getProductMaster();
    }
  }, [deleteProductMasterStatus, getProductMaster])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.productMaster }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);
  
  useEffect(() => {
    if (saveProductMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getProductMaster();
    } 
  }, [saveProductMasterStatus, closeModal, getProductMaster]);

  useEffect(() => {
    if (updateProductMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getProductMaster();
    } 
  }, [updateProductMasterStatus, closeModal, getProductMaster]);

  return useMemo(() => ({
    productMasterData,
    productMasterStatus,
    productMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    productMasterData,
    productMasterStatus,
    productMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
